import { Controller } from "@hotwired/stimulus";
import baguetteBox from "baguettebox.js/dist/baguetteBox.js";

export default class extends Controller {
  static targets = ["refreshLink", "media"];

  connect() {
    baguetteBox.run(".gallery", { filter: /.*/i }); // filter enables urls with no extension
  }

  refreshImage() {
    if (this.hasMediaTarget && this.hasRefreshLinkTarget && !this.regex.test(this.mediaTargetPath)) {
      this.refreshLinkTarget.click();
    }
  }

  get regex() {
    return /\.(jpe?g|png|gif|bmp|webp|svg|mp3)(\?.*)/i;
  }

  get mediaTargetPath() {
    const url = new URL(this.mediaTarget.src);
    return url.pathname; // Returns the path part of the URL without parameters
  }
}
